<template>
	<div class="keywordcustom">
		<div class="text_box">
			<van-field
			v-model="content"
			rows="6"
			type="textarea"
			maxlength="500"
			placeholder="请输入关键词"
			show-word-limit
			/>
		</div>
		<div class="choose_term">
			<div style="flex: 1"></div>
			<div class="search_btn" @click="saveKey()">提交</div>
		</div>
		<div class="tips">温馨提示：</div>
		<div class="tips">若输入多项关键词内容，请在内容之间使用英文逗号“,”隔开，或换行进行区分</div>
	</div>
</template>
<script>
	import admin from '../../api/admin';
	import { mapState } from 'vuex';
	import { Col, Row,Search,Cell,Toast,DatetimePicker,Field,Popup,Button,Dialog } from 'vant';
	export default {
		data () {
			return {
				day_type:1,
				content:'',
				text:'',
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user
			})
		},
		mounted() {
		},
		created () {
			if(this.$route.query.token){
				this.token = this.$route.query.token
				this.$store.dispatch('param/setToken', this.$route.query.token)
			}
			if(localStorage.getItem('editKey')){
				var params = JSON.parse(localStorage.getItem('editKey'))
				this.id=params.id
				this.content=params.content
				localStorage.removeItem('editKey')
			}
		},
		methods: {
			saveKey(val) {
				if(this.id){
					var parmas={
						id:this.id,
						content:this.content
					}
					admin.editKey(parmas).then(res => {
						if(res.data.state==1){
							// wx.miniProgram.navigateBack({delta:1})
							wx.miniProgram.reLaunch({url:'/pages/webview/webview?scene=keywordnegative'})
						}else{

						}
					})
				}else{
					var parmas={
						content:this.content
					}
					admin.addKey(parmas).then(res => {
						if(res.data.state==1){
							// wx.miniProgram.navigateBack({delta:1})
							wx.miniProgram.reLaunch({url:'/pages/webview/webview?scene=keywordnegative'})
						}else{

						}
					})
				}
			},
		},
		components: {
			[Col.name]: Col,
			[Row.name]: Row,
			[Search.name]:Search,
			[Cell.name]:Cell,
			[Toast.name]:Toast,
			[DatetimePicker.name]:DatetimePicker,
			[Field.name]:Field,
			[Popup.name]:Popup,
			[Button.name]:Button,
			[Dialog.name]:Dialog
		}
	}
</script>
<style lang="scss">
.keywordcustom{
	padding: 20px;
	.text_box{
		border: 1px solid #BBBBBB;
		border-radius: 4px;
		.van-cell{
			font-size: 14px;
			background-color: transparent;
		}
	}
	.choose_term{
		display: flex;
		align-items: center;
		font-size: 12px;
		margin-bottom: 40px;
		.time_btn{
			border-radius:4px;
			border:1px solid #666666;
			color: #000000;
			margin: 5px;
			padding:6px 12px;
		}
		.time_btn_active{
			background-color:#666666;
		}
		.search_btn{
			color: #fff;
			border:1px solid #333333;
			background-color: #333333;
			border-radius:4px;
			margin: 5px;
			padding:6px 18px;
		}
	}
	.tips{
		font-size: 12px;
		color: #666666;
	}
}
</style>